import React from 'react';


const StoryHeader = ({ title, date }) => (
  <header style={{ textAlign: 'center' }}>
    <h2>{title}</h2>
    <p>{date}</p>
  </header>
);

export default StoryHeader;



// WEBPACK FOOTER //
// ./src/components/StoryHeader.js